import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { trackQuestionInteraction } from '../services/gtmService';

const QuestionCard = ({ number, question, parts }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Reset visibility when switching to a different question
  useEffect(() => {
    setIsVisible(false);
  }, [number, question]);

  const toggleVisibility = () => {
    const newVisibility = !isVisible;
    setIsVisible(newVisibility);

    // GTM: Track question expand/collapse
    trackQuestionInteraction(number, newVisibility ? 'expand' : 'collapse');
  };

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200">
      <div className="p-4 sm:p-6">
        <div className="cursor-pointer flex items-start gap-3 sm:gap-4" onClick={toggleVisibility}>
          <span className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-br from-green-600 to-emerald-700 text-white rounded-full flex items-center justify-center font-bold text-xs sm:text-sm">
            {number}
          </span>
          <h3 className="text-base sm:text-lg font-semibold text-gray-800 flex-1">
            {question}
          </h3>
          <span className="text-xl sm:text-2xl text-gray-500 transition-transform duration-300" style={{ transform: isVisible ? 'rotate(180deg)' : 'rotate(0deg)' }}>
            ▼
          </span>
        </div>

        {isVisible && (
          <div className="pl-10 sm:pl-12 max-w-none">
            {parts.map((part, index) =>
              part.type === 'code' ? (
                <SyntaxHighlighter language={part.language} key={index}>
                  {part.content}
                </SyntaxHighlighter>
              ) : (
                <div key={index} className="prose prose-slate max-w-none text-gray-700">
                  <ReactMarkdown
                    components={{
                      ul: ({node, ...props}) => <ul className="list-disc pl-5 sm:pl-6 my-3 space-y-1" {...props} />,
                      ol: ({node, ...props}) => <ol className="list-decimal pl-5 sm:pl-6 my-3 space-y-1" {...props} />,
                      li: ({node, ...props}) => <li className="text-gray-700" {...props} />,
                      p: ({node, ...props}) => <p className="my-2 text-sm sm:text-base" {...props} />,
                      code: ({node, inline, ...props}) =>
                        inline ? <code className="bg-gray-100 px-1.5 py-0.5 rounded text-sm font-mono" {...props} /> : <code {...props} />
                    }}
                  >
                    {part.content}
                  </ReactMarkdown>
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionCard;
